import React from 'react';
import {appBaseName} from '@/config';

const Separator = () => (
  <img
    src={`${appBaseName}/assets/images/separator.png`}
    width='500px'
    alt='separator'
    style={{maxWidth: '100%'}}
  />
);

export default Separator;
